module.exports = __webpack_public_path__ + "media/images/interests/talk-077ce761c61f5a9ad631c17e5f9f3e20.png";